import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import html from "@/gen/home";

export default function HomePage() {
  usePageMeta("Where the field meets the market");
  return <HtmlBlock html={html} testId="home-page" />;
}
